<template>
    
    <div class="actions">
        <button v-if="move" @click.stop.prevent="$emit('moveleft')" class="button"><b-icon pack="mdi" icon="chevron-left"></b-icon></button>
        <button v-if="remove" @click.stop.prevent="$emit('remove')" class="button"><b-icon pack="mdi" icon="close"></b-icon></button>
        <button v-if="drag" :class="['button', draghandle]"><b-icon pack="mdi" icon="move"></b-icon></button>
        <button v-if="flip" @click.stop.prevent="$emit('flip')" class="button"><b-icon pack="mdi" icon="rotate-3d"></b-icon></button>
        <button v-if="move" @click.stop.prevent="$emit('moveright')" class="button"><b-icon pack="mdi" icon="chevron-right"></b-icon></button>
    </div>

</template>

<script>


export default {

  name: 'Actions',

  props: ['move', 'drag', 'remove', 'flip', 'draghandle']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.actions button{
    border-radius:100%;
    border:0;
    height:35px;
    width:35px;
    margin:2px;
}

</style>